<pbc-sorter [config]="GutachtenStatiSorterConfig" [sorter]="gutachtenStati.sorter$ | async" (sorterChange)="gutachtenStati.sorter$.next($event)"></pbc-sorter>
